import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button1 from "./button1";
import Button2 from "./button2";
import "../styles/playpage.css";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchCompleteFloridaManDailyProblemCreationAsync,
  incrementGamesPlayedAsync,
} from "./gameSlice.jsx";

const FloridaMan = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const today = new Date().toDateString();
  const [audio] = useState(new Audio("/prison-cell-door-sound-effect.mp3"));
  const { daily } = useSelector((state) => state.game);
  const borderColorOptions = ["#ed6d1b", "purple", "green"];

  const [enhancedDaily, setEnhancedDaily] = useState([]);
  const [selections, setSelections] = useState({});
  const [lives, setLives] = useState(["🍊", "🍊", "🍊"]);
  const [shuffledTitles, setShuffledTitles] = useState([]);

  useEffect(() => {
    if (daily.length === 0) {
      dispatch(fetchCompleteFloridaManDailyProblemCreationAsync());
    }
    if (daily.length > 0) {
      const enhancedItems = daily.map((item, index) => ({
        ...item,
        borderColor: borderColorOptions[index % borderColorOptions.length],
      }));
      setEnhancedDaily(enhancedItems);
      const titles = enhancedItems.map((item) => ({
        id: item.id,
        title: item.title,
        borderColor: item.borderColor,
      }));
      setShuffledTitles(shuffleArray(titles));
    }
  }, [daily]);

  useEffect(() => {
    if (lives.length === 0) navigate("/result");
  }, [lives, navigate]);

  const handleImageTap = (id) => {
    if (Object.values(selections).includes(id)) {
      return; // If assigned, ignore this tap
    }
    const image = enhancedDaily.find((item) => item.id === id);
    if (image) {
      // Unselect previous selection if exists and it's the same type
      if (selections.currentType === "image") {
        delete selections[selections.currentSelection];
      }
      // Set the current selection to this image
      selections.currentSelection = id;
      selections.currentType = "image";
      setSelections({ ...selections });
    }
  };

  function shuffleArray(array) {
    const arrayCopy = [...array]; // Make a copy to prevent modifying the original array
    for (let i = arrayCopy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arrayCopy[i], arrayCopy[j]] = [arrayCopy[j], arrayCopy[i]]; // ES6 destructuring swap
    }
    return arrayCopy;
  }

  const handleTitleTap = (titleId) => {
    if (selections.currentType === "image") {
      setSelections((prev) => ({
        ...prev,
        [titleId]: selections.currentSelection,
        currentSelection: null,
        currentType: null,
      }));
    }
  };

  const handleSubmit = () => {
    if (Object.keys(selections).length !== enhancedDaily.length + 2) {
      alert("Please make a selection for each title before submitting.");
      return;
    }
    const correctMatches = enhancedDaily.filter(
      (item) => selections[item.id] === item.id
    ).length;

    if (correctMatches === enhancedDaily.length) {
      audio.play();
      localStorage.setItem("lastPlayed", today);
      dispatch(incrementGamesPlayedAsync());
      navigate("/result");
    } else {
      setLives((lives) => (lives.length > 1 ? lives.slice(0, -1) : []));
      setSelections({}); // Reset selections for next try
    }
  };

  const resetGame = () => {
    setSelections({});
    setLives(["🍊", "🍊", "🍊"]);
  };

  function getNextPlayTime() {
    const now = new Date();
    const tomorrow = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1
    );
    const msUntilTomorrow = tomorrow - now;

    // Convert milliseconds to hours, minutes, and seconds
    const hours = Math.floor(msUntilTomorrow / 3600000);
    const minutes = Math.floor((msUntilTomorrow % 3600000) / 60000);
    const seconds = Math.floor((msUntilTomorrow % 60000) / 1000);

    return `${hours} hours, ${minutes} minutes, and ${seconds} seconds`;
  }

  const nextPlayTime = getNextPlayTime();

  const lastPlayed = localStorage.getItem("lastPlayed");

  if (lastPlayed === today) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <p>You have already played today. Come back tomorrow!</p>

        <p>
          Save the game onto your Mobile Device by, hitting the share icon in
          your browser and hit the add to home screen, so you can play easily on
          a mobile device Next game available on:
          <span style={{ fontWeight: 600, color: "#ed6d1b" }}>
            {nextPlayTime}
          </span>{" "}
        </p>

        <h3>Save the game on your Mobile Device:</h3>
        <img style={{ width: "300px" }} src="/shareIconOnBrowser.jpg"></img>
        <h3>Then</h3>
        <img style={{ width: "300px" }} src="/AddToHome.jpeg"></img>
        <Button1
          onClick={() => {
            // localStorage.removeItem("lastPlayed");
            // window.location.reload();
            audio.play();
            navigate("/result");
          }}
        >
          See Today's Results
        </Button1>
        {/* <Button1
          onClick={() => {
            localStorage.removeItem("lastPlayed");
            window.location.reload();
            // audio.play();
            // navigate("/result");
          }}
        >
          Remove Local Storage
        </Button1> */}
      </div>
    );
  } else {
    return (
      <div>
        <p>Tap on each Florida Man image and then on his correct headline.</p>
        <h3>Lives Left: {lives}</h3>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {enhancedDaily.map((item) => (
            <img
              key={item.id}
              src={item.img}
              alt="Florida Man"
              onClick={() => handleImageTap(item.id)}
              style={{
                width: "100px",
                height: "120px",
                margin: "10px",
                border: `5px solid ${item.borderColor}`,
                opacity: Object.values(selections).includes(item.id) ? 0.5 : 1,
                cursor: "pointer",
                borderRadius: "20px",
                objectFit: "cover",
              }}
            />
          ))}
        </div>
        <div>
          {shuffledTitles.map((item) => (
            <div
              key={item.id}
              onClick={() => handleTitleTap(item.id)}
              className="torn-paper"
              style={{
                height: "100px",
                border: `15px solid ${
                  selections[item.id]
                    ? enhancedDaily.find((x) => x.id === selections[item.id])
                        .borderColor
                    : "black"
                }`,
              }}
            >
              <h3>{item.title}</h3>
            </div>
          ))}
        </div>
        <div style={{ justifyContent: "space-evenly", display: "flex" }}>
          <Button1 onClick={handleSubmit}>Play</Button1>
          <Button2 onClick={resetGame}>Reset</Button2>
        </div>
        {lives.length === 0 && <p>Game Over. Try again!</p>}
      </div>
    );
  }
};

export default FloridaMan;
